import type { StatusTone } from '../../../ui-kit';
import type { PsRequestCard } from '../../../services/policyServicingService';

/**
 * The chip a request wears, in every list and in its story. Short and the
 * same length whatever the carrier — the carrier has its own column.
 */
const CHIPS: Record<PsRequestCard['status'], { tone: StatusTone; label: string }> = {
  received: { tone: 'neutral', label: 'Just arrived' },
  understood: { tone: 'neutral', label: 'Finding the policy' },
  policy_found: { tone: 'neutral', label: 'Waiting to call' },
  calling: { tone: 'good', label: 'On the call' },
  call_ended: { tone: 'neutral', label: 'Reading the answer' },
  asked_carrier: { tone: 'neutral', label: 'Waiting for the carrier' },
  carrier_replied: { tone: 'neutral', label: 'Reading the answer' },
  answered: { tone: 'neutral', label: 'Writing the reply' },
  reply_drafted: { tone: 'warning', label: 'Waiting for approval' },
  replied: { tone: 'good', label: 'Replied' },
  needs_person: { tone: 'warning', label: 'Needs a person' },
  discarded: { tone: 'neutral', label: 'Discarded' },
};

export function statusChip(
  request: Pick<PsRequestCard, 'status' | 'stage'> & Pick<Partial<PsRequestCard>, 'employer_id' | 'draft_waiting'>,
): { tone: StatusTone; label: string } {
  // A request about an employer's employee has no policy to find: our records are checked instead.
  if (request.employer_id && request.status === 'understood') return { tone: 'neutral', label: 'Checking our records' };
  // Handed to a person with a reply drafted for them: it waits on their approval.
  if (request.status === 'needs_person' && request.draft_waiting) return { tone: 'warning', label: 'Draft to check' };
  return CHIPS[request.status] ?? { tone: 'neutral', label: request.stage };
}
